export default __webpack_public_path__ + "static/media/rm5.67763235.png";